<div
  class="element-wrapper {{ elementActionsKeyRoot }} {{ elementActionsKey }}"
  [style]="wrapperStyles"
>
  @let visibleHeaderActions = (visibleHeaderActions$ | async) ?? [];
  @if (labelEnabled || visibleHeaderActions.length) {
    <div blazeAvoidCloseButton class="header-row mb-16" [style]="headerStyles">
      @if (labelEnabled) {
        <blaze-element-header
          [color]="props?.style?.container?.title?.color1"
          [fontFamily]="props?.style?.titleBlock?.fontFamily"
          [fontSize]="props?.style?.titleBlock?.fontSize"
          [fontStyle]="props?.style?.titleBlock?.fontStyle"
          [fontWeight]="props?.style?.titleBlock?.fontWeight"
          [horizontalAlign]="props?.content?.title?.align"
          [icon]="props?.content?.title?.icon"
          [iconColor]="props?.content?.title?.iconColor?.color1"
          [iconPosition]="props?.content?.title?.iconPosition"
          [iconSize]="props?.style?.titleBlock?.iconSize"
          data-cy="FormContainer:title"
          class="header-title"
        >
          {{ labelText }}
        </blaze-element-header>
      }
      @if (visibleHeaderActions.length) {
        <div class="header-actions">
          @for (action of visibleHeaderActions; track $index) {
            <button
              (click)="onHeaderAction(action, $event)"
              [class.flex-row-reverse]="action.iconPosition === 'right'"
              [ngClass]="getActionClasses(action.styleSheetTarget ?? action.styleSheetId)"
              [blazeTooltip]="action.label"
              blazeClickable
              blazeIconButton="bat"
              blazeIconButtonSize="xl"
              class="header-action-btn"
              attr.data-cy="FormContainer:headerAction:{{ action.label }}"
            >
              @if (action.icon) {
                <span class="icon">
                  <mat-icon [svgIcon]="action.icon" />
                </span>
              }
              @if (action.showInlineLabel || !action.icon) {
                <span class="empty:hidden">{{ action.label | textLimit: 25 }}</span>
              }
            </button>
          }
        </div>
      }
    </div>
  }
  @if (!showNoDataPanel) {
    <div class="form-slots">
      @for (slotId of slots?.slotIds; track slotId) {
        <div [blazeSlotNode]="slots?.slotNodesData?.[slotId]" [style]="slotStyles">
          @if (noBindingMessage$ | async; as emptyMessage) {
            <div class="hint-generate">
              <span class="description">{{ emptyMessage }}</span>
            </div>
          }
          <ng-container
            *ngTemplateOutlet="slots?.templates?.[slotId] || null; context: slotElementContext"
          />
        </div>
      }
    </div>
  } @else {
    <div [style]="noDataStyles" class="no-data">{{ noDataMessage }}</div>
  }
</div>
